var SearchAPI = require("../../api").Search;

 angular
  .module("app.directives")
  .directive("globalSearch", function () {
    return {
      restrict: "E",
      template: require("./template.pug"),
      replace:true,
      scope: {
        isSearching: '='
      },
      link: function (scope, element, attrs) {
        scope.searchQuery = "";
        scope.results = [];

        scope.search = function (txt) {
          if (!txt) {
            scope.searched = null;
            scope.results = [];
            return;
          }
          SearchAPI.GetBasicGlobalSearch(txt, "Relevance", 5, 1).then(function (result) {
            scope.searched = txt;
            scope.results = result.results;
          });
        }

        scope.cancel = function(){
          scope.isSearching = false;
        }

        scope.getHref = function (result) {
          if (result.type == "Funder") {
            return "/funders/" + result.publicUrl;
          } else if (result.type == "Scheme") {
            return "/funders/" + result.publicUrl;
          } else if (result.type == "Project") {
            return "/project/" + result.publicUrl;
          } else if (result.type == "Applicant") {
            return "/applicants/" + result.publicUrl;
          } else if(result.type == "Fundraiser") {
           return "/fundraiser/" + result.publicUrl;
         }
        }
      }
    }
  });
